import React from 'react'
import ConfirmedTicketsComponent from './../../../../components/confirmed-tickets/confirmed-tickets.component'
import { connect } from 'react-redux'

class ConfirmedTicketsContainer extends React.Component {
	render() {
		const { isReturn, passengers, ticketsGoing, ticketsReturn } = this.props

		return (
			<ConfirmedTicketsComponent
				{...{ isReturn, passengers, ticketsGoing, ticketsReturn }}
			/>
		)
	}
}

const mapStateToProps = ({ ticketSale }) => ({
	passengers: ticketSale.passengers,
	ticketsGoing: ticketSale.confirmedTicketsGoing,
	ticketsReturn: ticketSale.confirmedTicketsReturn,
})

const ConfirmedTickets = connect(mapStateToProps)(ConfirmedTicketsContainer)

export default ConfirmedTickets
